import { render, staticRenderFns } from "./detailCard.vue?vue&type=template&id=3a1b9e9f&scoped=true"
import script from "./detailCard.vue?vue&type=script&lang=js"
export * from "./detailCard.vue?vue&type=script&lang=js"
import style0 from "./detailCard.vue?vue&type=style&index=0&id=3a1b9e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b9e9f",
  null
  
)

export default component.exports